/**
 * BJAF PDP main gallery: click-and-drag to swipe with a mouse.
 * Touchscreens already swipe natively (the gallery is a real scroll container
 * with scroll-snap), this only adds the same left/right swipe behavior for
 * desktop mouse users, who have no native drag-to-scroll gesture.
 */
(function () {
  'use strict';

  function init() {
    var carousel = document.querySelector('.template-product .product-gallery__media-list');
    if (!carousel) {
      return;
    }

    var isDown = false;
    var moved = false;
    var startX = 0;
    var startScrollLeft = 0;
    var DRAG_THRESHOLD = 6;
    var rafId = null;
    var pendingDeltaX = 0;
    var hasPendingFrame = false;

    function applyPendingScroll() {
      hasPendingFrame = false;
      carousel.scrollLeft = startScrollLeft - pendingDeltaX;
    }

    function onPointerDown(event) {
      // Touch/pen already scroll the carousel natively; only take over for mouse.
      if (event.pointerType !== 'mouse' || event.button !== 0) {
        return;
      }
      isDown = true;
      moved = false;
      startX = event.clientX;
      startScrollLeft = carousel.scrollLeft;
      // Grabbing pointer capture keeps receiving move/up events even if the
      // cursor briefly leaves the carousel mid-drag (fast mouse movement).
      if (carousel.setPointerCapture) {
        try {
          carousel.setPointerCapture(event.pointerId);
        } catch (e) {
          /* Ignore: not critical if capture isn't available. */
        }
      }
    }

    function onPointerMove(event) {
      if (!isDown) {
        return;
      }
      pendingDeltaX = event.clientX - startX;
      if (Math.abs(pendingDeltaX) > DRAG_THRESHOLD) {
        if (!moved) {
          moved = true;
          carousel.classList.add('is-dragging');
        }
        event.preventDefault();
        // Batch the scrollLeft write to once per animation frame instead of once
        // per pointermove (which can fire far faster than the screen repaints
        // and was causing the drag to feel stuttery instead of smooth).
        if (!hasPendingFrame) {
          hasPendingFrame = true;
          rafId = requestAnimationFrame(applyPendingScroll);
        }
      }
    }

    function endDrag(event) {
      if (!isDown) {
        return;
      }
      isDown = false;
      carousel.classList.remove('is-dragging');
      if (rafId !== null) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }
      // If a scrollLeft write was queued for the next frame but pointerup fired
      // first, apply it now so the snap-to-nearest-slide check below doesn't
      // read a stale scrollLeft from before the final pointer position.
      if (hasPendingFrame) {
        applyPendingScroll();
      }
      if (carousel.releasePointerCapture && event && event.pointerId !== undefined) {
        try {
          carousel.releasePointerCapture(event.pointerId);
        } catch (e) {
          /* Ignore: capture may already be released. */
        }
      }

      // We moved scrollLeft directly instead of a native scroll gesture, so the
      // browser's scroll-snap never engaged. Snap to the nearest slide ourselves,
      // using the carousel's own API (same one the arrow buttons use).
      if (moved && typeof carousel.select === 'function' && carousel.itemOffset && carousel.items) {
        var nearestIndex = Math.round(carousel.scrollLeft / carousel.itemOffset);
        var maxIndex = carousel.items.length - 1;
        nearestIndex = Math.max(0, Math.min(maxIndex, nearestIndex));
        carousel.select(nearestIndex);
      }
    }

    // Dragging still ends in a mouseup over the image, which would otherwise
    // trigger the theme's existing "click left/right half to advance" handler.
    // Swallow that one click so a drag doesn't also jump an extra slide.
    function onClickCapture(event) {
      if (moved) {
        event.preventDefault();
        event.stopPropagation();
        moved = false;
      }
    }

    // Images are draggable by default, so a mouse drag was starting the browser's
    // native "drag this image out" ghost-preview instead of our scroll-drag. Block it.
    function onDragStart(event) {
      event.preventDefault();
    }

    carousel.addEventListener('pointerdown', onPointerDown);
    carousel.addEventListener('pointermove', onPointerMove);
    carousel.addEventListener('pointerup', endDrag);
    carousel.addEventListener('pointerleave', endDrag);
    carousel.addEventListener('pointercancel', endDrag);
    carousel.addEventListener('click', onClickCapture, true);
    carousel.addEventListener('dragstart', onDragStart);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
